import React from "react";
import StoryCard6 from "../../../molecules/story-card6";

function LatestRecentNews({ stories }) {
  return (
    <>
      {stories?.slice(0, 10).map((item, index) => (
        <StoryCard6 story={item} key={index} headerType={10} />
      ))}
    </>
  );
}

export default LatestRecentNews;
